<template>
    <div v-if="Object.keys(model).length !== 0" class="wrapper">
        <item-form
            :model="model"
            :typeusers="typeusers"
            :bedrijven="bedrijven"
            :isEditing="true"
            @save-item="updateItem">
        </item-form>

        <b-modal title="Wijzigen" size="sm" class="modal-danger" v-model="warningModal" @ok="closedialog">
            FOUT: Account werd niet gewijzigd! {{errormsg}}
        </b-modal>
    </div>
</template>

<script>
    import api from '../../api/account';
    import ItemForm from './Form';

    export default {
        data () {
            return {
                warningModal: false,
                errormsg: '',
                typeusers: [],
                bedrijven: [],
                model: {},
            };
        },
        created () {
            api.getDetailUser(this.$route.params.id).then((response) => {
                this.typeusers = response.data.typeusers;
                this.bedrijven = response.data.bedrijven;
                this.model = response.data.model;
            });
        },
        methods: {
            updateItem (model) {
                api.updateUser(model).then(() => {
                    this.$router.replace('/beheer/account');
                },
                (error) => {
                    this.errormsg = error.message;
                    this.warningModal = true;
                });
            },
            closedialog () {
                this.warningModal = false;
            },
        },
        components: {
            'item-form': ItemForm,
        },
    };
</script>



// WEBPACK FOOTER //
// src/pages/account/Edit.vue